import axios from "../../service";

export const state = {
  partnerList: {
    report: [],
    total: 0
  },
  partnerListOption: {
    report: [],
    total: 0
  }
};

export const mutations = {
  INIT_PARTNER_LIST_OPTION(state, newValue) {
    if (newValue.length == 0) {
      state.partnerListOption.report = newValue;
      state.partnerListOption.total = newValue.length;
    } else {
      state.partnerListOption = newValue;
    }
  }
};

export const getters = {};

export const actions = {
  // async getPartnerOption({ commit }, data) {
  //     try {
  //         let resp = await axios.get("/user/report/partner-option", {
  //             params: {
  //                 ...data
  //             }
  //         });
  //         if (!resp) throw "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง";
  //         commit("INIT_PARTNER_LIST_OPTION", resp.data);
  //         return { status: true };
  //     } catch (err) {
  //         return { status: false, err: err };
  //     }
  // },
};
